<script setup lang="ts">
import { Project } from "@/types";
import { defineEmits, defineProps } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  project: Project;
  showDetails: boolean;
};

type Emits = {
  (event: "toggleDetails"): void;
};

defineProps<Props>();

defineEmits<Emits>();
const { t } = useTranslate();
</script>

<template>
  <div class="bg-[#F9F8F6] rounded-primary-radius">
    <div
      @click="$emit('toggleDetails')"
      class="flex items-center justify-between p-2 h-[48px] cursor-pointer"
    >
      <h2
        class="text-lg sm:text-[20px] leading-[30px] tracking-[0.01rem] text-primary-text-color font-semibold"
      >
        {{ t("phase.technical_details") }}
      </h2>
      <img
        class="cursor-pointer"
        :class="showDetails ? 'rotate-0' : 'rotate-180'"
        src="@/assets/chevron-up.svg"
        alt=""
      />
    </div>
    <div
      v-if="showDetails"
      class="flex flex-col lg:flex-row items-start p-3 pt-0 gap-3 h-[196px]"
    >
      <!-- Left -->
      <div class="flex-1 flex flex-col items-start gap-2">
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            VNB
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{ project?.vnb ? project?.vnb : "-" }}
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            Wechselrichter
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{ project?.wechselrichter ? project?.wechselrichter : "-" }}
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            Speicher
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{ project?.speicher ? project?.speicher : "-." }}
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            Masskonzept
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{ project?.masskonzept ? project?.masskonzept : "-" }}
          </p>
        </div>
      </div>
      <!-- Right -->
      <div class="flex-1 flex flex-col items-start gap-2">
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            WB
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{ project?.wb ? project?.wb : "-" }}
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            Number of Modules
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{ project?.numberOfModules ? project?.numberOfModules : "-" }}
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            Modul Type
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
          >
            {{ project?.modulType ? project?.modulType : "-" }}
          </p>
        </div>
        <div class="flex flex-col gap-1">
          <h4
            class="text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
          >
            IMB Date
          </h4>
          <p
            class="text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal"
          >
            {{
              project?.ibnDate
                ? new Date(project?.ibnDate).toLocaleDateString("de")
                : "-"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
